import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { PRODUCT_IMG, PRODUCT_NAME, CHECKOUT_URL } from './constants';
export function FinalCTA() {
  return <section className="py-10 px-4 bg-brand-navy text-white border-t-8 border-brand-gold" data-id="element-48" data-mp="c7tuhic0cosz">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49" data-mp="84xhq895fmwy">
        <p className="text-sm font-extrabold text-brand-gold uppercase tracking-widest mb-2" data-id="element-50" data-mp="87jq2a3v66g8">
          One Last Chance
        </p>

        <div className="text-base sm:text-lg font-medium mb-5 leading-snug max-w-2xl mx-auto space-y-2 text-white/90" data-id="element-51" data-mp="h6dhlm2c86mx">
          <p data-id="element-52" data-mp="vtgh1ya80pcw">
            Your athletes deserve more than practices planned at the last minute
            because you simply ran out of time.
          </p>
          <p data-id="element-53" data-mp="14vg2d2s9qfln">
            Stop spending hours creating practice plans, searching for drills,
            organizing progressions, and building season plans every single
            week. Stop wasting valuable time jumping between books, websites,
            videos, and scattered coaching files.
          </p>
          <p data-id="element-54" data-mp="2h37wsvy0ggy1">
            Deliver every practice with structure, confidence, and a
            professional coaching system built to help your athletes improve
            faster. Give yourself the complete gymnastics coaching system you
            wish you had from your very first practice.
          </p>
        </div>

        <a href={CHECKOUT_URL} className="block cursor-pointer" data-id="element-55" data-mp="2v2he5yxydh3l">
          <img src={PRODUCT_IMG} alt="Gymnastics Coach Pro 6-in-1 System" className="w-full max-w-[240px] mx-auto object-contain drop-shadow-2xl mb-5 hover:scale-[1.02] transition-transform duration-300" data-id="element-56" data-mp="302c3vz5zs0n2" />
        </a>

        <div className="bg-white/10 border border-white/20 rounded-2xl p-4 mb-5 shadow-lg" data-id="element-57" data-mp="39rn8p9luij55">
          <p className="text-sm sm:text-base font-bold mb-1 uppercase tracking-wide" data-id="element-58" data-mp="3et2syzg78lmh">
            🤸 {PRODUCT_NAME} — Complete 6-in-1 System + 5 Premium Bonuses
          </p>
          <p className="text-lg mb-0.5" data-id="element-59" data-mp="1jpekdek958tk">
            <span className="line-through opacity-70" data-id="element-60" data-mp="1jm8tbts2bwv7">Regular Price: $97</span>
          </p>
          <p className="text-4xl font-display font-extrabold text-brand-gold" data-id="element-61" data-mp="1en5q8evn80pv">
            Today Only: $27 USD
          </p>
        </div>

        <CTAButton href={CHECKOUT_URL} className="max-w-md mx-auto !bg-brand-gold !text-brand-ink border-brand-ink/20 shadow-[0_4px_14px_0_rgba(212,166,42,0.39)] hover:!bg-brand-gold/90 mb-4" data-id="element-62" data-mp="1npezz2j37q27">
          🚀 YES! I WANT MY GYMNASTICS COACH PRO™ SYSTEM
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs sm:text-sm font-bold text-white/90" data-id="element-63" data-mp="2bg18sw0x1ed9">
          <div className="flex items-center gap-1.5" data-id="element-64" data-mp="27f8ys0k7z5fx">
            <ZapIcon className="w-4 h-4 text-brand-gold" data-id="element-65" data-mp="h1i20h9ccopf" />
            <span data-id="element-66" data-mp="h20783dzed9h">Immediate Access • Delivered Instantly by Email</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-67" data-mp="d17xza5408d7">•</span>
          <div className="flex items-center gap-1.5" data-id="element-68" data-mp="2vg7bwzroj8s">
            <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-69" data-mp="2y2p0pgdgf4q" />
            <span data-id="element-70" data-mp="6w9wetoy4439">4.9/5 — Verified Coach Reviews</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-71" data-mp="3pc2gss4r4hqu">•</span>
          <div className="flex items-center gap-1.5" data-id="element-72" data-mp="3p9q2coy7cpij">
            <ShieldCheckIcon className="w-4 h-4 text-brand-gold" data-id="element-73" data-mp="3u9ch52toidtg" />
            <span data-id="element-74" data-mp="3fcv7cg151790">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}